import { useSelector } from "react-redux";

const useToken = () => {
  const csrfToken = useSelector(
    ({ applicationUser }) => applicationUser?.token
  );
  return csrfToken;
};

export default useToken;
